<template>
  <b-card header="$t('Configurações')" header-tag="h6" header-bg-variant="light" no-body>
    <template v-slot:header>
      <b-row class="container-custom">
        <div v-if="isLoading" class="m-3 d-flex justify-content-center w-100">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <div v-for="option in options" :key="option.id">
          <div
            class="card-custom mr-3"
            :class="selected && selected.id == option.id && 'active'"
            @click="setValue(option.id)"
          >
            <b-col class="text-center"><b-icon class="h4 m-0" icon="dice3"></b-icon></b-col>
            <b-col>
              <span class="text-nowrap" style="font-weight: 500">{{ option.nome }}</span>
            </b-col>
          </div>
        </div>
      </b-row>
    </template>
  </b-card>
</template>
<script>
export default {
  props: ['isRequired', 'defaultValue'],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },
  watch: {
    defaultValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.options.length > 0) {
          this.setValue(this.defaultValue);
        }
      }
    }
  },

  created() {
    this.isLoading = true;
    this.$atenaList
      .getCommon('tipo_produto', {
        columns: 'id,nome',
        order: 'nome'
      })
      .then((res) => {
        this.options = res.data;
        this.setValue(this.defaultValue || this.options[0].id);
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        this.$util.formWarn({
          msgTitle: 'Erro ao carre',
          msgContent: err.code + ' - ' + err.message,
          msgTranslate: false,
          type: 'error'
        });
      });
  },
  methods: {
    setValue(option) {
      if (option) {
        this.selected = this.options.find((opt) => opt.id == option);
        this.$emit('input', this.selected.id);
      } else {
        this.selected = null;
        this.$emit('input', this.selected);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  padding: 0.75rem 0 !important;
}
.container-custom {
  flex-wrap: nowrap;
  justify-content: space-evenly;
  overflow-x: auto;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 0.2rem !important;
  @media only screen and (max-width: 1200px) {
    justify-content: flex-start;
    padding: 0px 10px;
  }
  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
    padding: 0px 10px;
  }
}
.card-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 0.2rem;
}

.card-custom:hover,
.active {
  cursor: pointer;
  border-radius: 5px;
  background: #ffffff;
  color: #26b4ff;
}

.active {
  border: 1px solid rgb(218, 218, 218);
  color: #26b4ff;
}

/* width */
::-webkit-scrollbar {
  height: 5px;
  margin-top: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(212, 212, 212);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(223, 223, 223);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(184, 184, 184);
}
</style>
